// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1XEOx","right":"Footer_right__3c4_-","buttons":"Footer_buttons__1xZrZ"};